import { MDTypography } from "../../../../Component/Common/Components/MDTypography";
import { CertificatesTableMapper } from "./CertificatesColumns";
import { CertificateRegistry } from "../../../../Component/Model/Dto/CertificateRegistry/CertificateRegistry";
import { useEffect, useState } from "react";
import { CertificateRegistryService } from "../../../../Component/Api/VerificationAgency/CertificateRegistry/CertificateRegistryService";
import { EntriesPerPage } from "../../../../Component/Model/Table/Table";
import { DataTable } from "../../../../Component/Common/Components/DataTable/DataTable";
import { PortalDocumentService } from "../../../../Component/Api/PortalDocument/PortalDocumentUploadService";
import { VerificationAgencyService } from "../../../../Component/Api/VerificationAgency/VerificationAgencyService";
import { useRecoilValue } from "recoil";
import { BBBEEScorecardAtom } from "../../../../State/BBBEEScorecard.Atom";
import { NoDataScreen } from "../../../../Component/Common/Components/NoDataScreen/NoDataScreen";
import { MDBox } from "../../../../Component/Common/Components/MDBox";
import { IntermediateGlobalLoading } from "../../../../Component/Common/Components/Loading/IntermediateGlobalLoading";
import { UserAtom } from '../../../../State/user.Atom';

export const Certificates = () => {
    const [certificateData, setCertificateData] = useState<CertificateRegistry.CertificateRegistrySearchResult[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [companyName, setCompanyName] = useState<string>('');
    const scorecard = useRecoilValue(BBBEEScorecardAtom);
    const user = useRecoilValue(UserAtom);

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const handleDownloadCertificate = async (documentId: number) => {
        try {
            const response = await PortalDocumentService.GetById(documentId);
            window.open(response.data);
        } catch (error) {
            console.log(error);
        }
    }

    const fetchData = async (scorecardId: string) => {
        setIsLoading(true);
        try {
            let response = await CertificateRegistryService.GetLatestPublishedCertificate(scorecardId);
            setCertificateData(response.data.results);
            setFilteredItemsCount(response.data.filteredItemsCount);
            setTotalItemsCount(response.data.totalItemsCount);
        } catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading(false);
        }
    }

    const fetchCompanyName = async () => {
        try {
            let response;
            if(user.isAdmin && !user.hasAuditRole){
                response = await VerificationAgencyService.GetVaDetailsLinkedToSubmittedScorecard(scorecard.scorecardId);
            }
            else{
                response = await VerificationAgencyService.GetVaDetails();
            }
            setCompanyName(response.data.vaName);
        } catch (error) { }
    }

    useEffect(() => {
        fetchData(scorecard.scorecardId);
        fetchCompanyName();
    }, [entriesPerPage, pageNumber]);

    const certificateTableData = CertificatesTableMapper(certificateData, handleDownloadCertificate);

    return (
        <>
            <MDBox style={{ paddingBottom: "20px" }}>
                <MDTypography variant='h4' fontWeight='bold' >
                    Certificates Generated by {companyName}
                </MDTypography>
            </MDBox>
            {
                certificateData.length > 0 &&
                <DataTable
                    table={certificateTableData}
                    entriesPerPage={entriesPerPage}
                    pageNumber={pageNumber}
                    filteredItemsCount={filteredItemsCount}
                    totalItemsCount={totalItemsCount}
                    entriesPerPageChanged={entriesPerPageChanged}
                    pageNumberChanged={pageNumberChanged}
                    isLoading={isLoading}
                    canSearch={false}
                    manualSorting={false}
                    showEntriesPerPage={false}
                    showTotalEntries={false}
                    showBottomMargin={false}
                    isSorted={false}
                />
            }
            { isLoading &&
                <IntermediateGlobalLoading />
            }
            {
                !isLoading && certificateData.length === 0 &&
                <NoDataScreen
                    subText1="No certificates have been generated by your verification agency."
                    subText2="Feel free to reach out to your verification agency for more information." />
            }

        </>
    );
}